import Api from "./Api";
import axios from "axios";
import store from "../state/store";

function getCurrentLanguage(){
  return store.getters["i18N/getLanguage"]
}

function sendJourneyFlowId(params) {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };
  return axios.get(
    `${process.env.VUE_APP_BASE_URL}/api/check_image_qr_compliance_status_in_pre_registration/${getCurrentLanguage()}/${params}`,
    {
      headers: headers,
    }
  );
}
function createExpectedVisit(params) {
  return axios.post(
    `${process.env.VUE_APP_BASE_URL}/api/create-expected-visit/${getCurrentLanguage()}`,
    params
  ).then(response => {
    // console.log('service res', response);
    return Promise.resolve(response)
  })
    .catch(error => {
      // console.log('service err', error.response);
      return Promise.reject(error.response);
    });
}

function confirmExpectedVisit(params) {
  return axios.post(
    `${process.env.VUE_APP_BASE_URL}/api/confirm/visit/${getCurrentLanguage()}`,
    params
  ).then(response => {
    // console.log('service res', response);
    return Promise.resolve(response)
  })
    .catch(error => {
      // console.log('service err', error.response);
      return Promise.reject(error.response);
    });
}

function confirmExpectedVisitPassport(params) {
  return axios.post(
    `${process.env.VUE_APP_BASE_URL_PASSPORT}/api/visit/confirm`,
    params
  ).then(response => {
    // console.log('service res', response);
    return Promise.resolve(response)
  })
    .catch(error => {
      // console.log('service err', error.response);
      return Promise.reject(error.response);
    });
}

function editExpectedVisit(params) {
  return Api().put('/edit-expected-visit', params);
}

function deleteExpectedVisit(params) {
  return Api().delete('/delete-expected-visit', {
    params,
  });
}

function validateUserType(params) {
  return axios.post(
    `${process.env.VUE_APP_BASE_URL}/api/validate_user_type_pre_registration/${getCurrentLanguage()}`,
    params
  );
}

function checkUserEntity(params) {
  return axios.post(
    `${process.env.VUE_APP_BASE_URL}/api/check_user_entity/${getCurrentLanguage()}`,
    params
  );
}

function checkVisitExists(params) {
  return axios.post(
    `${process.env.VUE_APP_BASE_URL}/api/validate-expected-visit/${getCurrentLanguage()}`,
    params
  ).then(response => {
    return Promise.resolve(response)
  })
    .catch(error => {
      return Promise.reject(error.response);
    });
}

function approveVisit(params) {
  return Api().post('/approve-visit', params);
}

function rejectVisit(params) {
  return Api().post('/reject-visit', params);
}

function approveRejectedVisit(params) {
  return Api().post('/approve-rejected-visit', params);
}

function rejectApprovedVisit(params) {
  return Api().post('/reject-approved-visit', params);
}

function getPreRegDetails(id) {
  return axios.get(
    `${process.env.VUE_APP_BASE_URL}/api/visit-by-visit-url/${getCurrentLanguage()}/${id}`).then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error.response);
    });
}

function checkDuplicated(params) {
  return axios.post(
    `${process.env.VUE_APP_BASE_URL}/api/validate-user-update`,
    params).then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error.response);
    });
}

export default {
  sendJourneyFlowId,
  createExpectedVisit,
  confirmExpectedVisit,
  confirmExpectedVisitPassport,
  editExpectedVisit,
  deleteExpectedVisit,
  validateUserType,
  checkUserEntity,
  checkVisitExists,
  approveVisit,
  rejectVisit,
  approveRejectedVisit,
  rejectApprovedVisit,
  getPreRegDetails,
  checkDuplicated
};
